import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { IOnboarding } from '@/modules/Onboarding/types';
import { LearnMoreLink, Typography } from '@/shared/components/atoms';

import Arrow from '~/images/shared/arrow-up.svg';

const OnboardingCheckerItem: React.FC<IOnboarding.IOnboardingCheckerItem> = ({
  title,
  action,
  status,
  moreUrl,
  isDisabled = false,
  stepNumber,
  description,
}) => {
  const { t } = useTranslation('onboarding');

  return (
    <div
      className={clsx(
        'relative flex w-full items-center gap-12',
        isDisabled && 'opacity-5',
        isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
      )}
      onClick={isDisabled ? undefined : action}
    >
      <div
        className={clsx(
          'flex h-24 w-24 items-center justify-center rounded-full border-[0.2rem]',
          status === 'idle' ? 'border-surface-10' : 'border-secondary-20'
        )}
      >
        <div
          className={clsx(
            'h-9 w-9 rounded-full',
            status === 'idle' ? 'bg-background-transparent' : 'bg-secondary-20'
          )}
        ></div>
      </div>
      <div className='w-full'>
        <Typography
          variant='caption'
          className='text-surface-10'
          weight='medium'
        >
          {t('step-number', { number: stepNumber })}
        </Typography>
        <div className='text-base font-semi-bold'>{title}</div>
        <div className='text-14 text-surface-10'>
          {description} {moreUrl && <LearnMoreLink url={moreUrl} />}
        </div>
      </div>
      <div
        className={clsx(
          'w-fit text-24 text-primary-default ltr:rotate-90 rtl:-rotate-90'
        )}
      >
        <Arrow />
      </div>
    </div>
  );
};

export { OnboardingCheckerItem };
